import { render, staticRenderFns } from "./view__form.vue?vue&type=template&id=60449c26"
import script from "./view__form.vue?vue&type=script&lang=js"
export * from "./view__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports